module.exports = __webpack_public_path__ + "static/img/icon_wifi mall@2x.b5cf57fb.png";